module.exports = __webpack_public_path__ + "image/pro_function_bg.jpg";